/* eslint-disable import/no-unresolved */
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch } from "react-redux";
import { setStepDetails } from "src/redux/Actions/common";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

interface Props {
  label: string;
}
function ReviewHeading({ label }: Props) {
  const dispatch = useDispatch();
  const isJointAddendumState = useAppSelector((state: any) => state.isJointAddendum.isJointState);
  return (
    <div>
      <div className="flex justify-between mb-6">
        <div className="text-base font-bold cursor-pointer">{label}</div>
        <div className="rounded-full mr-10 !bg-lightGrayishRed">
          <EditIcon className="!text-base !pl-1 !text-hotShot" />
          <Button
            onClick={() => {
              //  console.log("loan details clicked before");
              if (label === "General Details") {
                dispatch(
                  setStepDetails({
                    parentStepNo: 1
                  })
                );
              }
              if (label === "Proposer Details") {
                dispatch(
                  setStepDetails({
                    parentStepNo: 2,
                    proposerStepNo: 1
                  })
                );
              }
              if (label === "Nominee Details") {
                dispatch(
                  setStepDetails({
                    parentStepNo: 2,
                    proposerStepNo: 3
                  })
                );
              }
              if (label === "Medical & LifeStyle") {
                dispatch(
                  setStepDetails({
                    parentStepNo: 2,
                    proposerStepNo: 4
                  })
                );
              }
              if (label === "NRI Details") {
                dispatch(
                  setStepDetails({
                    parentStepNo: 2,
                    proposerStepNo: 5
                  })
                );
              }
              if (label === "Joint Details") {
                dispatch(
                  setStepDetails({
                    parentStepNo: 3,
                    jointStepNo: 1
                  })
                );
              }
              if (label === "Assignment Notice") {
                if (isJointAddendumState === "yes") {
                  dispatch(
                    setStepDetails({
                      parentStepNo: 5
                    })
                  );
                } else {
                  dispatch(
                    setStepDetails({
                      parentStepNo: 4
                    })
                  );
                }
              }
              if (label === "Loan Details") {
                if (isJointAddendumState === "yes") {
                  dispatch(
                    setStepDetails({
                      parentStepNo: 4
                    })
                  );
                } else {
                  dispatch(
                    setStepDetails({
                      parentStepNo: 3
                    })
                  );
                }
              }
            }}
            className="!text-xxs !cursor-pointer !px-2 !py-1 !font-small !font-bold"
          >
            Edit Details
          </Button>
        </div>
      </div>
      <hr />
    </div>
  );
}

export default ReviewHeading;
